











































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import InsurerFilter from "@/components/report/filters/Insurers.vue";
import StatusFilter from "@/components/report/filters/Status.vue";
import SubStatusFilter from "@/components/report/filters/SubStatus.vue";
import ReferenceDateFilter from "@/components/report/filters/ReferenceDate.vue";
import AdmissionDischargeFilter from "@/components/report/filters/AdmissionDischarge.vue";


@Component({
  components: {
    InsurerFilter,
    StatusFilter,
    SubStatusFilter,
    ReferenceDateFilter,
    AdmissionDischargeFilter
  },
   computed: {
    insurerFilterOn: function () {
      return this.$store.state.gaps.filter.report.insurerList.length? true:false;
    },
    statusFilterOn: function () {
      return this.$store.state.gaps.filter.report.statusList.length? true:false;
    },
    subStatusFilterOn: function () {
      return this.$store.state.gaps.filter.report.subStatusList.length? true:false;
    },
    admissionDischargeFilterOn: function () {
      return this.$store.state.gaps.filter.report.admissionDischargeList.length? true:false;
    },
    referenceDateFilterOn: function () {
      return this.$store.state.gaps.filter.report.referenceDate.from !=null || this.$store.state.gaps.filter.report.referenceDate.to != null? true:false;
    }
  }


})


export default class MemberList extends Vue {
  @Prop(Array) readonly items!: Array<any>;
  @Prop(Object) readonly filter!: Object;

  lastShownFilter!: string;
  showInsurerFilter = false;
  showStatusFilter = false;
  showSubStatusFilter = false;
  showReferenceDateFilter = false;
  showAdmisionDischargeFilter = false;


  showHideFilter(filter: string) {
    if (this.lastShownFilter && this.lastShownFilter !== filter) {
      this.showHideFilter(this.lastShownFilter);
    }
    let show = false;
    switch (filter) {
      case "INSURER":
        show = !this.showInsurerFilter;
        this.showInsurerFilter = show;
        break;
      case "STATUS":
        show = !this.showStatusFilter;
        this.showStatusFilter = show;
        break;
     case "SUB-STATUS":
        show = !this.showSubStatusFilter;
        this.showSubStatusFilter = show;
        break;
    case "REFERENCE_DATE":
        show = !this.showReferenceDateFilter;
        this.showReferenceDateFilter = show;
        break;
      case "ADMISSION_DISCHARGE":
        show = !this.showAdmisionDischargeFilter;
        this.showAdmisionDischargeFilter = show;
        break;
    }
    this.lastShownFilter = show ? filter : "";
  }
}
